module.exports = {
      id: "icon_check-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#icon_check-usage",
      toString: function () {
        return this.url;
      }
    }